import { ShopsApiClient } from '@fourthwall/services/dist/ShopsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUpdateShopAnalyticsMutation = createMutationHook(
  ShopsApiClient.updateShopAnalytics,
  {
    mutationKey: ['updateShopAnalytics'],
  },
)
